<div>
  <img [src]="imagen" routerLink="/" alt="pagina no encontrada" loading="lazy" width="100%" height="100%" (error)="onImageError()" />
</div>
